import React, { useState } from "react";
import { Box, Card, Divider, Grid, Tab, Paper, Container } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import CommonTabs from "src/components/CommonTabs/CommonTabs";
import TabHeader from "src/components/TabHeader/TabHeader";
import { NodConfigurationRoute } from "../../configuration.routes";
import { AddPaymentType } from "./components/AddPaymentType/AddPaymentType";
import { useStyles } from "./components/style";
import { AddTaxesType } from "./components/AddTaxesType/AddTaxesType";
import { AddNominationParty } from "./components/AddNominationParty/AddNominationParty";
import { AddNominationPartyType } from "./components/AddPartynominationType/AddPartyNominationType";
import { AddStorageSlab } from "./components/AddStorageSlabs/AddStorageSlab";
import { AddPaymentAgent } from "./components/AddPaymentAgent/AddPaymentAgent";

function a11yProps(index: any) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

type Props = {};

export default function PaymentTypes({}: Props): React.ReactElement {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const { title: moduleName } = NodConfigurationRoute;
  const pageHeading = "Payments";

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <TabHeader module={moduleName} heading={pageHeading} link={NodConfigurationRoute.path} />
      <Box m={2} />
      <Grid container direction="row">
        <Grid item xs={12} md={12} className={classes.cardMainParent}>
          <Paper elevation={3} className={classes.cardMain}>
            <Box pl={2} pr={2}>
              <Grid container direction="row">
                <Grid item xs={12} md={7}>
                  <Typography className={classes.pageHeading}>{pageHeading}</Typography>
                </Grid>
              </Grid>
            </Box>
            <Box m={1}>
              <Divider />
            </Box>

            <Grid container>
              <Grid item xs={4} md={3} lg={2} component={Card}>
                <div className="configTabs">
                  <CommonTabs value={value} handleChange={handleChange} tabMinHeight={800}>
                    <Tab label="Type Of Payments" {...a11yProps(0)} />
                    <Tab label="Type Of Taxes" {...a11yProps(1)} />
                    <Tab label="Add Nomination Party/Forwarder" {...a11yProps(2)} />
                    <Tab label="Party Nomination Type" {...a11yProps(3)} />
                    <Tab label="Add Storage Slabs" {...a11yProps(4)} />
                    <Tab label="Add Agents" {...a11yProps(5)} />
                  </CommonTabs>
                </div>
              </Grid>

              <Grid item xs={8} md={9} lg={10} component={Card} className={classes.tabCardContent}>
                <Container className="configSubTabs" style={{ padding: "15px" }}>
                  <AddPaymentType value={value} index={0} />
                  <AddTaxesType value={value} index={1} />
                  <AddNominationParty value={value} index={2} />
                  <AddNominationPartyType value={value} index={3} />
                  <AddStorageSlab value={value} index={4} />
                  <AddPaymentAgent value={value} index={5} />
                </Container>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
